import React from 'react';
import PropTypes from 'prop-types';

export interface IfProps {
  condition?: any;
  render?: () => React.ReactNode;
  children?: React.ReactNode;
}

export const If = (props: IfProps): any =>
  props.condition ? (props.render ? props.render() : props.children) : null;

If.propTypes = {
  // condition: PropTypes.bool.isRequired,
  children: PropTypes.node,
  render: PropTypes.func,
};
